// ActivityPage.jsx — m3-06a route entry for the Agent Experience "Activity" destination.
//
// The Rails ActivityController renders #react-root with data-page="activity" and a
// server-resolved data-mode (standard|agent). This thin wrapper reads data-mode off the
// mount node (so a fresh server load lands in the right layout) and hands off to the
// two-mode shell, which then keeps mode in sync with the ?mode= search param + localStorage.
//
// m3-11 fleshes out the segmented tab control inside the shell; m3-13 the chat column.

import React from "react"
import { useParams } from "react-router-dom"
import AgentExperienceShell from "../shell/AgentExperienceShell.jsx"

function readDataMode() {
  try {
    const node = document.getElementById("react-root")
    return node ? node.getAttribute("data-mode") : null
  } catch (_e) {
    return null
  }
}

// companySlug: prop on the flat `activity` route; URL param on the canonical nested
// `companies/:companySlug/activity` route (same prop-or-params resolution LibraryPage uses —
// without the nested registration the canonical URL fell to the `*` BridgeLoader catch-all
// and spun forever).
export default function ActivityPage({ companySlug }) {
  const params = useParams()
  const slug = companySlug || params.companySlug || null
  const dataMode = readDataMode()
  return <AgentExperienceShell companySlug={slug} dataMode={dataMode} />
}
